import { MDCDialog } from "@material/dialog";
import "lite-youtube-embed";

const siteWrap = document.querySelector(".site-wrap");
const dialog = new MDCDialog(document.querySelector(".mdc-dialog"));

dialog.root.removeAttribute("hidden");

let videoTriggers = document.querySelectorAll("button[data-modal-trigger]");

// Empty variable to set video id after click of play button
let currentVideoID;

videoTriggers.forEach((trigger) => {
  trigger.addEventListener("click", () => {
    currentVideoID = trigger.getAttribute("data-videoid");
    dialog.open();
  });
});

dialog.listen("MDCDialog:opened", function () {
  let ytTemplate = dialog.content.querySelector("template");

  // Clone template and insert parms to youtube player
  let ytPlayer = ytTemplate.content
    .cloneNode(true)
    .querySelector("lite-youtube");
  ytPlayer.setAttribute("videoid", currentVideoID);
  ytPlayer.setAttribute(
    "parmas",
    `mute=1&controls=0&${currentVideoID}&loop=1&modestbranding=2&rel=0&enablejsapi=1&playlist=${currentVideoID}`
  );

  // Manually trigger play
  dialog.content.appendChild(ytPlayer);

  ytPlayer.querySelector("button").click();

  // Focus close button
  dialog.root.querySelector("button[data-mdc-dialog-initial-focus]").focus();

  // Hide content from screen reader while dialog is open
  siteWrap.setAttribute("aria-hidden", "true");
});

dialog.listen("MDCDialog:closing", function () {
  // Un-hide content from screen reader
  siteWrap.removeAttribute("aria-hidden");
});

dialog.listen("MDCDialog:closed", function () {
  let liteYt = dialog.content.querySelector("lite-youtube");
  liteYt.remove();
});
